"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _Text = _interopRequireDefault(require("../Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Asset = function Asset(props) {
  var name = props.name,
    src = props.src,
    size = props.size;
  var rootClass = (0, _useCss["default"])(function (theme) {
    return {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.size(0.5)
    };
  });
  var assetClass = (0, _useCss["default"])(function (theme) {
    return {
      backgroundColor: theme.palette.background.secondary.color,
      outline: "1px solid ".concat(theme.color(theme.palette.background.secondary.contrast, theme.palette.background.secondary.color, 0.25)),
      width: size,
      height: size,
      objectFit: 'scale-down',
      transitionDuration: '200ms'
    };
  });
  var textClass = (0, _useCss["default"])(function () {
    return {
      maxWidth: size,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      cursor: 'default'
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: rootClass,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: src,
      alt: name,
      className: assetClass
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text["default"], {
      variant: "code",
      weight: "bold",
      title: name,
      className: textClass,
      children: name
    })]
  });
};
var _default = Asset;
exports["default"] = _default;